export const defaultPhoneCode = '+1 US';
export const defaultISOCode = 'US';
